import React, { Component } from 'react'
import { Button } from '@material-ui/core'
import { Field, Form } from 'react-final-form'
import { FormattedMessage, injectIntl } from 'react-intl'
import MenuItem from '@material-ui/core/MenuItem'
import moment from 'moment'
import { connect } from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import SelectInput from 'components/common/Form/SelectInput'
import { reloadWidgetRateLogTable } from 'reducers/digitalLogbook/reducer'
import {
  openCageDrawer,
  setCageRate,
  reloadCageList,
} from 'reducers/slaMonitor/reducer'
import withPromise from 'helpers/withPromise'
import CheckboxButtonsField from 'components/common/Form/CheckboxButtonsField'
import ButtonCheckbox from 'components/common/Form/ButtonCheckbox'
import getValidator, { VALIDATOR_IS_EMPTY } from 'validation'
import TextArea from 'components/common/Form/TextArea'
import TimePickerInput from 'components/common/Form/TimePicker'
import DatePickerInput from 'components/common/Form/DatePicker'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import messages from '../translate'
import LogTable from './LogTable'
import { commments } from './translate'

const SPECIES_COHO = 'Coho'
const COMMENT_OPTIONS = [
  {
    label: messages.chooseComment,
    value: 'chooseComment',
  },
  {
    label: messages.typeComment,
    value: 'typeComment',
  },
]

class CageDrawer extends Component {
  constructor(props) {
    super(props)
    const { activeDate } = this.props
    const profile = this.props.profile.toJS()

    this.state = {
      id: null,
      date: activeDate.clone(),
      time: activeDate.clone(),
      comment: '',
      activeTab: COMMENT_OPTIONS[0].value,
      user: profile.id,
      specie: '',
      rate: null,
      pristine: true,
    }
  }

  onCloseCageDetails = () => {
    const { activeDate } = this.props
    const { specie } = this.state

    this.props.openCageDrawer({
      id: null,
      specie,
    })
    this.setState({
      date: activeDate.clone(),
      time: moment(),
      pristine: true,
      comment: '',
    })
  }

  componentDidMount() {
    this.intervalId = setInterval(() => {
      this.setState({ time: moment() })
    }, 60000)
  }

  componentWillUnmount() {
    clearInterval(this.intervalId)
  }

  componentDidUpdate(prevProps) {
    const { cageInfo, activeDate } = this.props

    if (cageInfo !== prevProps.cageInfo) {
      const { id, specie } = cageInfo.toJS()

      this.setState({ id, specie })
    }

    if (activeDate !== prevProps.activeDate) {
      this.setState({ date: activeDate, time: activeDate })
    }
  }

  onSubmit = ({ date, time, id, user, rate, comment }) => {
    const eventDate = `${date.format('YYYY-MM-DD')} ${time
      .utc()
      .format('HH:mm:ss')}`

    return withPromise(this.props.setCageRate, {
      params: {
        locusId: id,
        userId: user,
      },
      values: {
        eventDate,
        rate: Number(rate),
        comment,
      },
    }).then(errors => {
      if (errors) return Promise.resolve(errors)

      this.onCloseCageDetails()
      this.props.reloadCageList(true)
      this.props.reloadWidgetRateLogTable(true)
    })
  }

  onCageChange = (e, item) => {
    const { value, specie } = item.props

    if (value) {
      this.setState({ id: value, specie })
    }
  }

  onChangeTime = time => {
    const { activeDate } = this.props

    if (time !== activeDate) {
      clearInterval(this.intervalId)
      this.setState({ time: moment(time) })
    }
  }

  onChangeDate = date => this.setState({ date: moment(date) })

  onCommentChange = e => this.setState({ comment: e.target.value })

  onUserChange = e => this.setState({ user: e.target.value })

  transformComments() {
    const {
      intl: { formatMessage },
    } = this.props
    const keys = Object.keys(commments)

    return keys.reduce((resultArr, next) => {
      const item = formatMessage(commments[next])
      resultArr.push(item)

      return resultArr
    }, [])
  }

  onChangeComment = (e, tabValue) => {
    this.setState({ activeTab: tabValue })
  }

  getCommentTabs = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const { activeTab } = this.state

    return (
      <div className="form-group">
        <Tabs
          onChange={this.onChangeComment}
          value={activeTab}
          className="info-comment-box">
          {COMMENT_OPTIONS.map(comment => (
            <Tab
              label={formatMessage(comment.label)}
              value={comment.value}
              key={comment.value}
              className="info-comment-tab"
            />
          ))}
        </Tabs>
        {activeTab === COMMENT_OPTIONS[0].value ? (
          <Field
            name="comment"
            inputProps={{
              maxLength: 750,
            }}
            label={formatMessage(messages.addComment)}
            component={SelectInput}
            onChange={this.onCommentChange}>
            {this.transformComments().map(comment => (
              <MenuItem component="li" button key={comment} value={comment}>
                {comment}
              </MenuItem>
            ))}
          </Field>
        ) : (
          <Field
            name="comment"
            input={{
              onChange: this.onCommentChange,
            }}
            inputProps={{
              maxLength: 750,
            }}
            label={formatMessage(messages.addComment)}
            component={TextArea}
            multiline
          />
        )}
      </div>
    )
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props
    const profile = this.props.profile.toJS()
    const userList = [{ id: profile.id, name: profile.name }]
    const cages = this.props.cageList.toJS()

    return (
      <Dialog
        fullScreen={ifWindowWidthLessThan(599)}
        maxWidth="lg"
        open={Boolean(this.state.id)}
        onClose={this.onCloseCageDetails}
        className="cage-info-dialog">
        <DialogTitle className="info-title">
          <FormattedMessage {...messages.create} />
          <IconButton onClick={this.onCloseCageDetails} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <div className="info-content">
          <Form
            onSubmit={this.onSubmit}
            initialValues={this.state}
            mutators={{
              setRate: args => {
                this.setState({ rate: args[0], pristine: false })
              },
            }}
            render={({ handleSubmit, submitting, form: { mutators } }) => (
              <form onSubmit={handleSubmit} className="form-basic">
                <Field
                  name="id"
                  component={SelectInput}
                  label={formatMessage(messages.cage)}
                  disabled={submitting}
                  onChange={this.onCageChange}>
                  {cages.map(cage => (
                    <MenuItem
                      component="li"
                      button
                      key={cage.id}
                      specie={cage.specie}
                      value={cage.id}>
                      {cage.name}
                    </MenuItem>
                  ))}
                </Field>
                <Field
                  name="date"
                  type="text"
                  label={formatMessage(messages.date)}
                  component={DatePickerInput}
                  maxDate
                  onChange={this.onChangeDate}
                  disabled={submitting}
                />
                <Field
                  name="time"
                  type="text"
                  label={formatMessage(messages.time)}
                  component={TimePickerInput}
                  onChange={this.onChangeTime}
                  disabled={submitting}
                />
                <Field
                  name="user"
                  component={SelectInput}
                  label={formatMessage(messages.currentBy)}
                  disabled
                  onChange={this.onUserChange}
                  formControlProps={{ fullWidth: true, required: true }}
                  validate={getValidator([VALIDATOR_IS_EMPTY])}>
                  {userList.map(user => (
                    <MenuItem
                      component="li"
                      button
                      key={user.id}
                      value={user.id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Field>

                <CheckboxButtonsField
                  withFourRate={SPECIES_COHO !== this.state.specie}
                  onClick={mutators.setRate}
                />

                {this.getCommentTabs()}

                <Field
                  name="rate"
                  type="text"
                  component={ButtonCheckbox}
                  disabled={submitting}
                  required
                  validate={getValidator(VALIDATOR_IS_EMPTY)}
                />

                <div className="form-group buttons">
                  <div className="info-form">
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className="cage-rate-submit"
                      onClick={handleSubmit}
                      disabled={submitting || this.state.pristine}>
                      <FormattedMessage {...messages.submit} />
                    </Button>
                  </div>
                </div>
              </form>
            )}
          />
        </div>

        <div className="info-details">
          <LogTable
            activeSite={this.props.activeSite}
            activeCage={this.state.id}
            activeDate={this.state.date}
            isStateCriteria
          />
        </div>
      </Dialog>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    customerId: state.getIn(['profile', 'profile', 'id']),
    cageInfo: state.getIn(['slaMonitor', 'activeDrawerCage']),
    cageList: state.getIn(['slaMonitor', 'cageList']),
    profile: state.getIn(['profile', 'profile']),
  }),
  {
    openCageDrawer,
    setCageRate,
    reloadCageList,
    reloadWidgetRateLogTable,
  },
)(injectIntl(CageDrawer))
